<!-- ### https://amcnewshandler.amc.info/de/newsletter ### -->
<div class="container">
  <!--      <h1 class="text-headline">{{getFieldLabel("nl_heading")}}</h1>-->
  <h3><b>{{getFieldLabel("n_unsub_title")}}</b></h3>
  <!--      <div *ngIf="getFieldLabel('nl_heading_content_1') && getFieldLabel('nl_heading_content_2') &&-->
  <!--              getFieldLabel('nl_heading_content_3') && getFieldLabel('nl_heading_content_4') &&-->
  <!--              getFieldLabel('nl_heading_content_5') && getFieldLabel('nl_heading_content_6') ">-->
  <p></p>
  <div style="width: 30vw; max-width: 50vw; overflow: hidden; text-align: justify;">
    {{getFieldLabel("n_unsub_info")}}
  </div>

  <form id="newsletterForm" [formGroup]="amcContactform" (ngSubmit)="onSubmit()">
    <table class="table table-bordered">
      <thead>
      <tr>
        <th></th>
        <th>{{getFieldLabel("n_unsub_channel")}}</th>
        <th><b>{{getFieldLabel("n_unsub_is")}}</b><br/>{{getFieldLabel("n_unsub_is_2")}}</th>
        <th><b>{{getFieldLabel("n_unsub_ms")}}</b><br/>{{getFieldLabel("n_unsub_ms_2")}}</th>
        <th *ngIf="isCountryDE()"><b>{{getFieldLabel("n_unsub_nl")}}</b><br/>{{getFieldLabel("n_unsub_nl_2")}}</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>{{getFieldLabel("n_unsub_email")}}</td>
        <td><div class="checkbox-container"><input type="checkbox" [checked]="isAllEmailChannelCheckBoxChecked()" (change)="checkAllEmailChannelCheckBox($event)" formControlName="allEmailChannel" id="allEmailChannel" name="allEmailChannel"></div></td>
        <td><div class="checkbox-container"><input formControlName="email_is" type="checkbox" id="email_is" name="email_is"></div></td>
        <td><div class="checkbox-container"><input formControlName="email_ms" type="checkbox" id="email_ms" name="email_ms"></div></td>
        <td *ngIf="isCountryDE()"><div class="checkbox-container"><input formControlName="email_nl" type="checkbox"  id="email_nl" name="email_nl"></div></td>
      </tr>
      <tr>
        <td>{{getFieldLabel("n_unsub_post")}}</td>
        <td><div class="checkbox-container"><input formControlName="post" type="checkbox" id="post" name="post"></div></td>
      </tr>
      <tr>
        <td>{{getFieldLabel("n_unsub_phone")}}</td>
        <td><div class="checkbox-container"><input formControlName="phone" type="checkbox" id="phone" name="phone"></div></td>
      </tr>
      <tr>
        <td><b>{{getFieldLabel("n_unsub_all")}}</b></td>
        <td><div class="checkbox-container"><input type="checkbox" [checked]="isAllCheckBoxChecked()" (change)="checkAllCheckBox($event)" formControlName="all" id="all" name="all"></div></td>
      </tr>
      </tbody>
    </table>

    <!--    &lt;!&ndash; Button for for submit &ndash;&gt;-->
    <div class="form-group row">
      <div class="col-md-8 col-sm-8 col-xs-12">
        <button type="submit" id="subButtonAngular" name="subButtonAngular" class="button-rounded">
          {{getFieldLabel("n_unsub_btn")}}
        </button>
      </div>
    </div>
  </form>
</div>
<!--/body-->
